import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";
import { OFFER_ICON_DIM, TIMER_ICON_DIM } from "./constant";

export const DeliverySpeedOfferInfoContainer = styled(Text)<{ textColor?: string; gradient?: string }>(
    ({ theme, textColor, gradient }) => ({
        marginLeft: theme.spacing.xLarge,
        marginTop: theme.spacing.xSmall,
        width: "100%",
        "> div": {
            display: "flex",
            gap: theme.spacing.xxSmall,
            color: textColor,
            background: gradient,
            padding: `${theme.spacing.xSmall} ${theme.spacing.small}`,
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            borderRadius: theme.cornerRadius.medium,
            flexShrink: 0,
            whiteSpace: "nowrap",
            "> img": {
                height: OFFER_ICON_DIM.HEIGHT,
                width: "auto",
                objectFit: "contain",
                objectPosition: "center",
            },
            "> div": {
                display: "flex",
                alignItems: "center",
                gap: theme.spacing.xxSmall,
                "> img": {
                    height: TIMER_ICON_DIM.HEIGHT,
                    width: "auto",
                    objectFit: "contain",
                    objectPosition: "center",
                },
            },
        },
    }),
);
